export default ({ children }: any) => {
  return <p className="description">{children}</p>
}
